import { _ } from '../../vendor'

/**
 * Iterate through [contingent.]tags, return only
 * the tags with actual sizes
 * 
 * @param {String/Array} tags 
 * @return {String}
 */
export const formatContingentTags: (tags: any) => string = (tags: any): string => {

    if (typeof tags === 'string' && tags.indexOf('(') >= 0) {
        return tags;
    }

    if (typeof tags === 'undefined' || tags == '') {
        return '';
    }

    let result: string = '';

    if (typeof tags === 'string') {
        // @ts-ignore
        if (tags == 'XS' || tags == 'S' || tags == 'M' || tags == 'L' || tags == 'XL' || tags == 'XXL' || tags == '24 Zoll' || tags == '26 Zoll') {
            result = ' (' + tags + ')';
        }
    } else {

        _.each(tags, (tag: any, key: any): void => {

            let label: string = (typeof tag === 'string' ? tag : tag.label);

            if (label == 'XS' || label == 'S' || label == 'M' || label == 'L' || label == 'XL' || label == 'XXL' || label == '24 Zoll' || label == '26 Zoll') {
                result = ' (' + label + ')';
            }

        });
    }

    return result;
}

/**
 * Formats a number according to Inbooma specification
 * (e.g. 23.2345 becomes 23,23)
 * @param {Number/String} num 
 * @return {String} 
 */
export const currencyFormat: (num: any) => string = (num: any): string => {
    return (
        Number(num)
            .toFixed(2) // always two decimal digits
            .replace('.', ',') // replace decimal point character with ,
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    ) // use . as a separator
}

export const dateFormat: (lang: string, long?: boolean, withTime?: boolean) => string = (lang: string, long: boolean = false, withTime: boolean = false): string => {
    const language: string = lang.substring(0,2);
    if(language === 'API'){
        return 'YYYY-MM-DD'+(withTime?" "+timeFormat('API'):"");
    }
    switch (language) {
        case "de":
            return long?'dd, DD.MM.YY'+(withTime?' '+timeFormat(lang):''):'DD.MM.YY'+(withTime?' '+timeFormat(lang):'');
        case "en":
            return long?'dd, DD/MM/YYYY'+(withTime?' '+timeFormat(lang):''):'DD/MM/YYYY'+(withTime?' '+timeFormat(lang):'');
        default:
            return long?'dd, DD.MM.YY'+(withTime?' '+timeFormat(lang):''):'DD.MM.YY'+(withTime?' '+timeFormat(lang):'');
    }
}

export const timeFormat: (lang: string) => (string) = (lang: string): string => {
    const language: string = lang.substring(0,2);
    switch (language) {
        case "de":
            return 'HH:mm';
        case "en":
            return 'hh:mm A';
        default:
            return 'HH:mm';
    }
}